import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from './api';

const slice = createSlice({
  name: 'auth',
  initialState: {
    fredAccessToken: '',
    fredTokenExpiration: '',
    fredRefreshToken: '',
    error: false
  },
  reducers: {
    // actions => action handlers
    // command - event
    changeCreds: (state, action) => {
      state.fredAccessToken = action.payload.accessToken
      state.fredTokenExpiration = Date.now() + 1000 * 60 * 10;
      state.fredRefreshToken = action.payload.refreshToken
      state.error = false
    },

    logout: (state, action) => {
      state.fredAccessToken = ''
      state.fredTokenExpiration = ''
      state.fredRefreshToken = ''
    },

    loginFailed: (state, action) => {
      state.error = true
    },

    renewCreds: (state, action) => {
      state.fredTokenExpiration = action.payload.fredTokenExpiration
      state.fredRefreshToken = action.payload.fredRefreshToken
    }
  }
})
 
// /*export*/ const { changeCreds, removeCreds } = slice.actions;
export const { changeCreds, logout, loginFailed, renewCreds } = slice.actions;
export default slice.reducer;

export const login = (username, password) => (dispatch, getState) => {
  const url = `/userSessions`;

  return dispatch(
    apiCallBegan({
      url,
      method: 'post',
      auth: { username, password },
      onSuccess: changeCreds.type,
      onError: loginFailed.type
    })
  )
}

export const renewAccess = () => (dispatch, getState) => {
  const url = `/userSessions`;

  return dispatch(
    apiCallBegan({
      url,
      method: 'put',
      data: {accessToken: getState().auth.fredAccessToken, refreshToken: getState().auth.fredRefreshToken},
      auth: '',
      onSuccess: changeCreds.type,
      onError: logout.type
    })
  )
}
